module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    class: [_vm.toolbarTransparent ? 'toolbar-transparent' : 'grey lighten-4'],
    attrs: {
      "fixed": ""
    }
  }, [_c('router-link', {
    staticClass: "hidden-sm-and-down",
    attrs: {
      "to": "/home"
    }
  }, [(_vm.logoShow) ? _c('img', {
    attrs: {
      "src": "/src/assets/images/logo/logo_2_sm.png",
      "height": "70px",
      "width": "auto"
    }
  }) : _vm._e()]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-sm-and-down"
  }, [_vm._l((_vm.links), function(link) {
    return _c('v-btn', {
      key: _vm.i,
      staticClass: "blue--text",
      attrs: {
        "flat": "",
        "router": "",
        "to": ("/" + (link.route))
      }
    }, [_vm._v("\n      " + _vm._s(_vm.$t(link.name)) + "\n    ")])
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "origin": "top right",
      "transition": "v-slide-y-transition"
    }
  }, [_c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "slot": "activator",
      "flat": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
    model: {
      value: (_vm.locale),
      callback: function($$v) {
        _vm.locale = $$v
      },
      expression: "locale"
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("language")))]), _vm._v(" "), _vm._l((_vm.languages), function(lang) {
    return _c('v-list-item', {
      key: lang.id
    }, [_c('v-list-tile', [_c('v-list-tile-title', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.locale),
        expression: "locale"
      }],
      attrs: {
        "type": "radio",
        "id": lang.id
      },
      domProps: {
        "value": lang.id,
        "checked": _vm._q(_vm.locale, lang.id)
      },
      on: {
        "change": function($event) {
          _vm.locale = lang.id
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": lang.id
      }
    }, [_vm._v(_vm._s(lang.name))])])], 1)], 1)
  })], 2)], 1)], 2), _vm._v(" "), _vm._l((_vm.links), function(link) {
    return _c('v-btn', {
      key: _vm.i,
      staticClass: "blue--text hidden-md-and-up",
      attrs: {
        "icon": "",
        "router": "",
        "to": ("/" + (link.route)),
        "title": _vm.$t(link.name)
      }
    }, [_c('v-icon', [_vm._v(_vm._s(link.icon))])], 1)
  }), _vm._v(" "), _c('v-menu', {
    staticClass: "hidden-md-and-up",
    attrs: {
      "bottom": "",
      "left": "",
      "offset-y": "",
      "origin": "top right",
      "transition": "v-slide-y-transition"
    }
  }, [_c('v-btn', {
    staticClass: "blue--text",
    attrs: {
      "slot": "activator",
      "icon": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
    model: {
      value: (_vm.locale),
      callback: function($$v) {
        _vm.locale = $$v
      },
      expression: "locale"
    }
  }, [_c('v-subheader', [_vm._v(_vm._s(_vm.$t("language")))]), _vm._v(" "), _vm._l((_vm.languages), function(lang) {
    return _c('v-list-item', {
      key: lang.id
    }, [_c('v-list-tile', [_c('v-list-tile-title', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.locale),
        expression: "locale"
      }],
      attrs: {
        "type": "radio",
        "id": lang.id
      },
      domProps: {
        "value": lang.id,
        "checked": _vm._q(_vm.locale, lang.id)
      },
      on: {
        "change": function($event) {
          _vm.locale = lang.id
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": lang.id
      }
    }, [_vm._v(_vm._s(lang.name))])])], 1)], 1)
  })], 2)], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00b466cc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/sections/Toolbar.vue
// module id = 430
// module chunks = 0